import { render } from "./CourseNativeVideo.vue?vue&type=template&id=4750bdc8&scoped=true"
import script from "./CourseNativeVideo.vue?vue&type=script&lang=js"
export * from "./CourseNativeVideo.vue?vue&type=script&lang=js"

import "./CourseNativeVideo.vue?vue&type=style&index=0&id=4750bdc8&scoped=true&lang=css"
import "./CourseNativeVideo.vue?vue&type=style&index=1&id=4750bdc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4750bdc8"]])

export default __exports__